<template>
    <div class="ks-rsy-ad">
        <div class="ks-rsy-ad-body">
            <h6 v-if="title" v-text="title" :class="{'ks-row-page-ads': inContainer}"></h6>
            <div v-if="secondTitle" v-text="secondTitle" :class="{'ks-row-page-ads': inContainer}"></div>
            <div v-if="body" v-text="body" :class="{'ks-row-page-ads': inContainer}"></div>
            <div v-if="companyName" v-text="companyName" :class="{'ks-row-page-ads': inContainer}"></div>
            <div class="ks-row-page-ads" v-if="adUrl">
                Ссылка: <a :href="adUrl" target="_blank" v-text="adUrl"></a>
            </div>
        </div>
    </div>
</template>

<script>
import KsImg from "./KsImg.vue";
import S3storage from "../../mixins/S3storage";

export default {
    name: "KsRsyAd",
    props: {
        inContainer: {
            type: Boolean
        },
        title: {
            type:String,
            required: false,
        },
        secondTitle: {
            type:String,
            required: false,
        },
        body: {
            type:String,
            required: false,
        },
        companyName: {
            type:String,
            required: false,
        },
        adUrl: {
            type:String,
            required: true,
        }
    }
}
</script>

<style scoped>
.ks-rsy-ad {
    display: flex;
}
.ks-rsy-ad-body {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
